import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const useBackPage = () => {
  const location = useLocation()

  const [backPage, setBackPage] = useState(() => {
    return calculateBackPage(location.pathname)
  })

  useEffect(() => {
    const newBackPage = calculateBackPage(location.pathname)
    setBackPage(newBackPage)
  }, [location.pathname])

  return backPage
}

const calculateBackPage = (pathname) => {
  const segments = pathname.split('/').filter(Boolean)

  if (segments.includes('edit')) {
    const editIndex = segments.indexOf('edit')
    if (editIndex > 0) {
      const baseSegments = segments.slice(0, editIndex)
      return '/' + baseSegments.join('/')
    }
  }

  if (segments.includes('new')) {
    const newIndex = segments.indexOf('new')
    if (newIndex > 0) {
      const baseSegments = segments.slice(0, newIndex)
      return '/' + baseSegments.join('/')
    }
  }

  if (segments.includes('details')) {
    const showIndex = segments.indexOf('details')
    if (showIndex > 0) {
      const baseSegments = segments.slice(0, showIndex)
      return '/' + baseSegments.join('/')
    }
  }

  return '/'
}

export default useBackPage
